module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "element element-container-single element-non-bodymatter element-type-none element-with-heading",
    attrs: {
      "id": "uncategorized"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "uncategorized-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Book Description")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "uncategorized-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("Twin hybrid vampires Daniel and Diana feel technology’s cold, uncountable tendrils hunting them. Daniel scientifically satisfies his needs. Diana hunts old-school, leaving patches of greasy, scorched earth or mutilated bodies for her brother to take care of.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Daniel created Matrix, a face pack for beauty shops, which pulls blood through skin, leaves blissful clients, kills and alerts no one. He prefers milking to butchering. Daniel cultivates his human side; Diana mocks him. Impatient, she hunts out of spite as much as need.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Daniel finally understands that his twin sister will get him killed, and his life’s hardest decision is at hand: Blood? Or Death?")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0feff2f1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bookdescription.vue
// module id = 60
// module chunks = 0